export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "packing_house_certification": {
            "certification_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Certificación"])},
            "certification_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código"])},
            "expiration_date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fecha de expiración"])},
            "active": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Activo"])},
            "renewal_date": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fecha de renovación"])},
            "certificate_file": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Certificado"])},
            "expired_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Expira en"])}
          }
        }
      }
    }
  })
}